import SettingService from "../services/SettingService";
import { apiBody } from "../apiResponse";
export default {
    state: {
        positionList: [],
        departmentTree: [],
    },
    getters: {
        getPositionList(state) {
            return state.positionList;
        },
        getDepartmentTree(state) {
            return state.departmentTree;
        },
    },
    mutations: {
        updatePositionList(state, payload) {
            state.positionList = payload;
        },
        updateDepartmentTree(state, payload) {
            state.departmentTree = payload;
        },
    },
    actions: {
        getPositionList({ commit, dispatch }, payload) {
            return SettingService.getPositions().then((res) => {
                const b = apiBody(res);
                const data = b.data;
                if (res && data && data.length !== 0) {
                    commit("updatePositionList", data);
                }
            });
        },
        getDepartmentTree({ commit, dispatch }, payload) {
            return SettingService.getDepartmentTree().then((res) => {
                const b = apiBody(res);
                const data = b.data;
                if (res && data && data.length !== 0) {
                    commit("updateDepartmentTree", data);
                }
            });
        }
    }
};
